import { BRAND } from "constants/brand";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useArea from "hooks/useArea";
import { fieldOf } from "utils/formField";

const AddRegion = (props) => {
    const form = useRef();
    const nodeRef = useRef();
    const { loading, addArea, error } = useArea();

    const submitHandler = async (e) => {
        e.preventDefault();
        const regionData = new FormData();

        regionData.append(
            "image",
            fieldOf(form.current, "image").files[0],
            fieldOf(form.current, "image").files[0].name,
        );

        regionData.append("name", fieldOf(form.current, "name").value);
        regionData.append("cityId", fieldOf(form.current, "cityId").value);
        regionData.append("location", fieldOf(form.current, "location").value);

        try {
            const response = await addArea(regionData);
            // Assuming `response` contains information to check if the operation succeeded

            if (response.area) {
                props.showMessage("success", "تمت الاضافه", "تمت إضافه ألمنطقه بنجاح");
                props.close(); // Uncomment if you need to close a modal or similar
            } else {
                props.showMessage("error", "هناك خطأ", response.message || "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", error || "حدث خطأ غير متوقع");
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>إضافه منطقه</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="image">
                                <Form.Label>
                                    صوره المنطقه<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="image"
                                    type="file"
                                    accept=".png,.jpg,.jpeg,.svg,.webp"
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label>
                                    اسم المنطقه<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="name"
                                    type="text"
                                    placeholder="اسم القسم"
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="status">
                                <Form.Label>
                                    المدينه<span>*</span>
                                </Form.Label>
                                <Form.Select name="cityId">
                                    {props.cities?.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="location">
                                <Form.Label>الموقع</Form.Label>
                                <Form.Control name="location" type="text" placeholder="" />
                            </Form.Group>
                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    إضافه منطقه
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default AddRegion;
